import React from 'react';
import PropTypes from 'prop-types';

import NoContent from './no-content';
import { FFList } from '../ff-list';
import LoadMore from '../load-more';

class FFBase extends React.Component {
  _renderEmpty() {
    const { isOwnProfile, pageType, goToMembersPage, isAllMembersInstalled } = this.props;
    return (
      <NoContent
        isOwnProfile={isOwnProfile}
        pageType={pageType}
        onViewMembersClick={() => goToMembersPage()}
        showViewMembersButton={isAllMembersInstalled}
      />
    );
  }

  _renderMembers() {
    const { membersIds, goToMemberPage, goToFFPage, onRoleAction, isMobile } = this.props;
    return (
      <FFList
        membersIds={membersIds}
        goToFFPage={goToFFPage}
        goToMemberPage={goToMemberPage}
        onRoleAction={onRoleAction}
        isMobile={isMobile}
      />
    );
  }

  _renderContent() {
    const { membersIds } = this.props;
    return membersIds.length > 0 ? this._renderMembers() : this._renderEmpty();
  }

  renderAnimatedContent() {
    const { isLoading, fetchMembers, hasMoreMembers, isMobile } = this.props;
    return (
      <LoadMore loadMore={fetchMembers} isLoading={isLoading} hasMore={hasMoreMembers} isMobile={isMobile}>
        {this._renderContent()}
      </LoadMore>
    );
  }

  render() {
    return this.renderAnimatedContent();
  }
}

FFBase.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  hasMoreMembers: PropTypes.bool.isRequired,
  fetchMembers: PropTypes.func.isRequired,
  membersIds: PropTypes.array.isRequired,
  pageType: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
  onRoleAction: PropTypes.func.isRequired,
  isOwnProfile: PropTypes.bool.isRequired,
  goToFFPage: PropTypes.func.isRequired,
  goToMemberPage: PropTypes.func.isRequired,
  goToMembersPage: PropTypes.func.isRequired,
  isAllMembersInstalled: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool.isRequired,
};

export default FFBase;
